var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCPlusBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "misc"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 1.18359,
    width: 30.5,
    height: 30.5,
    rx: 15.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 1.18359,
    width: 30.5,
    height: 30.5,
    rx: 15.25,
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "|",
    x: 15.375,
    y: 10.3086,
    width: 1.25,
    height: 12.25,
    rx: 0.625,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_",
    x: 9.875,
    y: 17.0586,
    width: 1.25,
    height: 12.25,
    rx: 0.625,
    transform: "rotate(-90 9.875 17.0586)",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCPlusBlack);
export default __webpack_public_path__ + "static/media/c-plus-black.6f06160cda8894a10ffc80aa6640f793.svg";
export { ForwardRef as ReactComponent };